<template>
	<div class="item" @click="navDetail()">
		<div class="row user" v-if="showUser">
			<van-image class="avatar" :src="item.answer.avatar" fit="cover" round />
			<div class="col user-info">
				<span class="nickname">{{ item.answer.nickname }}</span>
				<span class="event" v-if="false">发布了问题</span>
			</div>
			<div class="row cc auth" v-if="item.answer.is_cert == 1">
				<van-image class="auth-img" :src="require('@/assets/auth-1.png')" fit="cover" />
				<span>{{ item.answer.major_name }}</span>
			</div>
		</div>
		<div class="date" v-else>{{ item.answer.create_time_text }} 回答了问题：</div>
		<div class="answer-content text-ellipsis-2">
			<span class="accept" v-if="item.answer.is_accept == 1">[已采纳]</span>
			<span class="accept" v-else>[未采纳]</span>
			<div v-html="item.answer.content"></div>
		</div>
		<div class="row cb que-view">
			<div class="col que-left">
				<div class="que-title text-ellipsis-2">{{ item.content }}</div>
				<div class="row info">
					<span>{{ item.view_num }}浏览</span>
					<span>{{ item.focus_num }}关注</span>
					<span>{{ item.answer_num }}回答</span>
				</div>
			</div>
			<van-image v-if="item.image" class="que-img" :src="img(item.image)" fit="cover" />
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	props: {
		showUser: {
			type: Boolean,
			default: true
		},
		item: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	computed: {
		img(val) {
			return val => {
				if (val == '') {
					return '';
				} else {
					return this.$store.getters.oss(val.split(',')[0]);
				}
			};
		}
	},
	data() {
		return {};
	},
	methods: {
		navDetail() {
			this.$router.push({
				path: '/ask/detail',
				query: { id: this.item.id }
			});
		}
	}
};
</script>

<style scoped lang="less">
@import './common.less';
</style>
